import { GETQUESTIONNAIRE, RESETQUESTIONNAIRE } from "../constants/Patient";

export default (state = {}, action) => {
  switch (action.type) {
    case GETQUESTIONNAIRE:
      return Object.assign({}, state, action.payload);
    case RESETQUESTIONNAIRE:
      return {};
    default:
      return state;
  }
};
